module.exports = __webpack_public_path__ + "static/img/nguyenthanhhang.ea91087.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nguyenthanhhang.jpg
// module id = nqDw
// module chunks = 1